"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.promoteChallengesMetaSelector = exports.promoteChallengesDataSelector = exports.noGlobalActiveChallengesSelector = exports.noGlobalChallengesSelector = exports.isRegisteredToAllActiveChallengesSelector = exports.isRegisteredToAllChallengesSelector = exports.finishedChallengesMetaSelector = exports.finishedChallengesDataSelector = exports.nextChallengesMetaSelector = exports.nextChallengesDataSelector = exports.activeChallengesDataWithoutPromoteSelector = exports.currentChallengesMetaSelector = exports.currentChallengesDataSelector = exports.activeChallengesHighlightSelector = exports.activeChallengesMetaSelector = exports.registeredFinishedChallengesMetaSelector = exports.registeredFinishedChallengesDataSelector = exports.registeredCurrentWithoutPromoteChallenges = exports.registeredCurrentChallengesMetaSelector = exports.registeredCurrentChallengesDataSelector = void 0;

var _reselect = require("reselect");

var _get = _interopRequireDefault(require("lodash/get"));

var challengesSelector = function challengesSelector(state) {
  return (0, _get["default"])(state, 'challenges');
};

var registeredCurrentChallengesSelector = (0, _reselect.createSelector)([challengesSelector], function (challenges) {
  return (0, _get["default"])(challenges, 'registeredCurrentChallenges');
});
var registeredCurrentChallengesDataSelector = (0, _reselect.createSelector)([registeredCurrentChallengesSelector], function (challenges) {
  return (0, _get["default"])(challenges, 'data');
});
exports.registeredCurrentChallengesDataSelector = registeredCurrentChallengesDataSelector;
var registeredCurrentChallengesMetaSelector = (0, _reselect.createSelector)([registeredCurrentChallengesSelector], function (challenges) {
  return (0, _get["default"])(challenges, 'meta');
});
exports.registeredCurrentChallengesMetaSelector = registeredCurrentChallengesMetaSelector;
var registeredCurrentWithoutPromoteChallenges = (0, _reselect.createSelector)([registeredCurrentChallengesDataSelector], function (challenges) {
  return Array.isArray(challenges) ? challenges.filter(function (challenge) {
    var _challenge$display;

    return !(challenge === null || challenge === void 0 ? void 0 : (_challenge$display = challenge.display) === null || _challenge$display === void 0 ? void 0 : _challenge$display.promote);
  }) : challenges;
});
exports.registeredCurrentWithoutPromoteChallenges = registeredCurrentWithoutPromoteChallenges;
var registeredFinishedChallengesSelector = (0, _reselect.createSelector)([challengesSelector], function (challenges) {
  return (0, _get["default"])(challenges, 'registeredFinishedChallenges');
});
var registeredFinishedChallengesDataSelector = (0, _reselect.createSelector)([registeredFinishedChallengesSelector], function (registeredFinishedChallenges) {
  return (0, _get["default"])(registeredFinishedChallenges, 'data');
});
exports.registeredFinishedChallengesDataSelector = registeredFinishedChallengesDataSelector;
var registeredFinishedChallengesMetaSelector = (0, _reselect.createSelector)([registeredFinishedChallengesSelector], function (registeredFinishedChallenges) {
  return (0, _get["default"])(registeredFinishedChallenges, 'meta');
});
exports.registeredFinishedChallengesMetaSelector = registeredFinishedChallengesMetaSelector;
var activeChallengesSelector = (0, _reselect.createSelector)([challengesSelector], function (challenges) {
  return (0, _get["default"])(challenges, 'activeChallenges');
});
var activeChallengesDataSelector = (0, _reselect.createSelector)([activeChallengesSelector], function (activeChallenges) {
  return (0, _get["default"])(activeChallenges, 'data');
});
var activeChallengesMetaSelector = (0, _reselect.createSelector)([activeChallengesSelector], function (activeChallenges) {
  return (0, _get["default"])(activeChallenges, 'meta');
});
exports.activeChallengesMetaSelector = activeChallengesMetaSelector;
var activeChallengesHighlightSelector = (0, _reselect.createSelector)(activeChallengesDataSelector, function (activeChallenges) {
  return activeChallenges && activeChallenges.filter(function (challenge) {
    return challenge.display && challenge.display.highlight;
  });
});
exports.activeChallengesHighlightSelector = activeChallengesHighlightSelector;
var currentChallengesBaseSelector = (0, _reselect.createSelector)([challengesSelector], function (challenges) {
  return (0, _get["default"])(challenges, 'currentChallenges');
});
var currentChallengesDataSelector = (0, _reselect.createSelector)([currentChallengesBaseSelector], function (currentChallenges) {
  return (0, _get["default"])(currentChallenges, 'data');
});
exports.currentChallengesDataSelector = currentChallengesDataSelector;
var currentChallengesMetaSelector = (0, _reselect.createSelector)([currentChallengesBaseSelector], function (currentChallenges) {
  return (0, _get["default"])(currentChallenges, 'meta');
});
exports.currentChallengesMetaSelector = currentChallengesMetaSelector;
var activeChallengesDataWithoutPromoteSelector = (0, _reselect.createSelector)([activeChallengesDataSelector], function (currentChallenges) {
  return Array.isArray(currentChallenges) ? currentChallenges.filter(function (challenge) {
    var _challenge$display2;

    return !((_challenge$display2 = challenge.display) === null || _challenge$display2 === void 0 ? void 0 : _challenge$display2.promote);
  }) : currentChallenges;
});
exports.activeChallengesDataWithoutPromoteSelector = activeChallengesDataWithoutPromoteSelector;
var nextChallengesBaseSelector = (0, _reselect.createSelector)([challengesSelector], function (challenges) {
  return (0, _get["default"])(challenges, 'nextChallenges');
});
var nextChallengesDataSelector = (0, _reselect.createSelector)([nextChallengesBaseSelector], function (challenges) {
  return (0, _get["default"])(challenges, 'data');
});
exports.nextChallengesDataSelector = nextChallengesDataSelector;
var nextChallengesMetaSelector = (0, _reselect.createSelector)([nextChallengesBaseSelector], function (nextChallenges) {
  return (0, _get["default"])(nextChallenges, 'meta');
});
exports.nextChallengesMetaSelector = nextChallengesMetaSelector;
var finishedChallengesBaseSelector = (0, _reselect.createSelector)([challengesSelector], function (challenges) {
  return (0, _get["default"])(challenges, 'finishedChallenges');
});
var finishedChallengesDataSelector = (0, _reselect.createSelector)([finishedChallengesBaseSelector], function (finishedChallenges) {
  return (0, _get["default"])(finishedChallenges, 'data');
});
exports.finishedChallengesDataSelector = finishedChallengesDataSelector;
var finishedChallengesMetaSelector = (0, _reselect.createSelector)([finishedChallengesBaseSelector], function (finishedChallenges) {
  return (0, _get["default"])(finishedChallenges, 'meta');
});
exports.finishedChallengesMetaSelector = finishedChallengesMetaSelector;
var isRegisteredToAllChallengesSelector = (0, _reselect.createSelector)([registeredCurrentChallengesSelector, currentChallengesDataSelector, nextChallengesDataSelector], function (registeredCurrentChallenges, currentChallengesData, nextChallengesData) {
  return registeredCurrentChallenges && registeredCurrentChallenges.data && registeredCurrentChallenges.data.length > 0 && currentChallengesData && currentChallengesData.length === 0 && nextChallengesData && nextChallengesData.length === 0;
});
exports.isRegisteredToAllChallengesSelector = isRegisteredToAllChallengesSelector;
var isRegisteredToAllActiveChallengesSelector = (0, _reselect.createSelector)([registeredCurrentChallengesDataSelector, activeChallengesDataSelector], function (registeredCurrentChallenges, activeChallenges) {
  return registeredCurrentChallenges && registeredCurrentChallenges.length > 0 && activeChallenges && activeChallenges.length === 0;
});
exports.isRegisteredToAllActiveChallengesSelector = isRegisteredToAllActiveChallengesSelector;
var noGlobalChallengesSelector = (0, _reselect.createSelector)([registeredCurrentChallengesSelector, currentChallengesDataSelector, nextChallengesDataSelector], function (registeredCurrentChallenges, currentChallengesData, nextChallengesData) {
  return registeredCurrentChallenges && registeredCurrentChallenges.data && registeredCurrentChallenges.data.length === 0 && currentChallengesData && currentChallengesData.length === 0 && nextChallengesData && nextChallengesData.length === 0;
});
exports.noGlobalChallengesSelector = noGlobalChallengesSelector;
var noGlobalActiveChallengesSelector = (0, _reselect.createSelector)([registeredCurrentChallengesDataSelector, activeChallengesDataSelector], function (registeredCurrentChallenges, activeChallenges) {
  return registeredCurrentChallenges && registeredCurrentChallenges.length === 0 && activeChallenges && activeChallenges.length === 0;
});
exports.noGlobalActiveChallengesSelector = noGlobalActiveChallengesSelector;
var promoteChallengesSelector = (0, _reselect.createSelector)([challengesSelector], function (challenges) {
  return (0, _get["default"])(challenges, 'promoteChallenges');
});
var promoteChallengesDataSelector = (0, _reselect.createSelector)([promoteChallengesSelector], function (promoteChallenges) {
  return (0, _get["default"])(promoteChallenges, 'data');
});
exports.promoteChallengesDataSelector = promoteChallengesDataSelector;
var promoteChallengesMetaSelector = (0, _reselect.createSelector)([promoteChallengesSelector], function (promoteChallenges) {
  return (0, _get["default"])(promoteChallenges, 'meta');
});
exports.promoteChallengesMetaSelector = promoteChallengesMetaSelector;
var _default = {
  activeChallengesDataSelector: activeChallengesDataSelector,
  activeChallengesMetaSelector: activeChallengesMetaSelector,
  activeChallengesHighlightSelector: activeChallengesHighlightSelector,
  activeChallengesDataWithoutPromoteSelector: activeChallengesDataWithoutPromoteSelector,
  currentChallengesDataSelector: currentChallengesDataSelector,
  currentChallengesMetaSelector: currentChallengesMetaSelector,
  finishedChallengesDataSelector: finishedChallengesDataSelector,
  finishedChallengesMetaSelector: finishedChallengesMetaSelector,
  isRegisteredToAllActiveChallengesSelector: isRegisteredToAllActiveChallengesSelector,
  isRegisteredToAllChallengesSelector: isRegisteredToAllChallengesSelector,
  nextChallengesDataSelector: nextChallengesDataSelector,
  nextChallengesMetaSelector: nextChallengesMetaSelector,
  noGlobalActiveChallengesSelector: noGlobalActiveChallengesSelector,
  noGlobalChallengesSelector: noGlobalChallengesSelector,
  promoteChallengesDataSelector: promoteChallengesDataSelector,
  promoteChallengesMetaSelector: promoteChallengesMetaSelector,
  registeredCurrentChallengesDataSelector: registeredCurrentChallengesDataSelector,
  registeredCurrentChallengesMetaSelector: registeredCurrentChallengesMetaSelector,
  registeredFinishedChallengesDataSelector: registeredFinishedChallengesDataSelector,
  registeredFinishedChallengesMetaSelector: registeredFinishedChallengesMetaSelector,
  registeredCurrentWithoutPromoteChallenges: registeredCurrentWithoutPromoteChallenges
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map